// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';
// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//     { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: '-',                      items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: '-',                      items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const BALJURASHI_PROFILE_CONFIG = {

//   // ── Baljurashi On-Street ─────────────────────────────────────────────
//   baljurashi_on_street_profile: {
//     profileKey:   'baljurashi_on_street_profile',
//     violationKey: 'baljurashi_on_street_violations',
//     assetsKey:    'baljurashi_on_street_assets',
//     pageType:     'on_street',

//     profileFallback: {
//       table_key: 'baljurashi_on_street_profile',
//       title: 'Baljurashi On Street - Profile',
//       data: {
//         total_bays:        { label: 'Total On-Street Parking Bays', value: '1,350' },
//         contract_term:     { value: '25 years' },
//         contract_period:   { start_date: '27/10/2021', end_date: '29/01/2046' },
//         operational_hours: { value: '14 Hours', from: '08:00', to: '22:00' },
//         rate_per_hour:     { value: 'SAR 03 + 15% VAT' },
//       },
//     },

//     violationFallback: {
//       table_key: 'baljurashi_on_street_violations',
//       title: 'Al Baljurashi On Street Violation Summary (Excluding Vat)',
//       data: {
//         rows: [
//           { city_code: 'BLJRSIE', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                    ticket_charges: '200',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',    ticket_charges: '100',           tow_charges: '-',       clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                    ticket_charges: '100',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                            ticket_charges: '100',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                         ticket_charges: '300',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                               ticket_charges: '300',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                   ticket_charges: '900',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                             ticket_charges: '500',           tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                          ticket_charges: '0',             tow_charges: '250/1250', clamp_charges: '0' },
//           { city_code: 'BLJRSIE', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                      ticket_charges: '20/50 per day', tow_charges: '0',       clamp_charges: '0' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'baljurashi_on_street_assets',
//       title: 'Baljurashi On-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evDipG100: '1',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '2', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '2', left: '2',
//           pnds: '72', tpalTx: '45', tpalV2: '27',
//           enfDevice: '-', printer: '20', bixolon: '20',
//           supportVehicle: '1',
//         }),
//       },
//     },
//   },

//   // ── Baljurashi Off-Street ────────────────────────────────────────────
//   baljurashi_off_street_profile: {
//     profileKey:    'baljurashi_off_street_profile',
//     assetsKey:     'baljurashi_off_street_assets',
//     pageType:      'off_street',

//     profileFallback: {
//       table_key: 'baljurashi_off_street_profile',
//       title: 'Baljurashi Off-Street Profile',
//       data: {
//         total_bays:        { label: 'Total Off Street Car Park Bays', value: '' },
//         contract_term:     { value: '' },
//         contract_period:   { start_date: '', end_date: '' },
//         operational_hours: { value: '', unit: 'Hours Per day' },
//         rate_per_hour:     { value: '' },
//         membership_rates:  { value: '' },
//       },
//     },

//     assetsFallback: {
//       table_key: 'baljurashi_off_street_assets',
//       title: 'Baljurashi Off-Street',
//       data: {
//         groups: makeAssetGroups({}), // all dashes — empty profile
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const BaljurashiProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = BALJURASHI_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving]             = useState(false);
//   const [profileTable, setProfileTable]     = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable]       = useState(cfg.assetsFallback);
//   const [violationTable, setViolationTable] = useState(cfg.violationFallback || null);
//   const { enqueue } = useApiQueue();

//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       if (cfg.violationKey) setViolationTable(find(cfg.violationKey, cfg.violationFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
//       const tables = [
//         { table_key: profileTable.table_key, title: profileTable.title, data: profileTable.data },
//         { table_key: assetsTable.table_key,  title: assetsTable.title,  data: assetsTable.data  },
//       ];
//       if (violationTable) tables.push({ table_key: violationTable.table_key, title: violationTable.title, data: violationTable.data });

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1, tables,
//       });
//       if (!res?.success) throw new Error(res?.message);
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleViolationCell = (rIdx, key, value) => {
//     setViolationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const pd         = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType   = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
      
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <>
//            <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//             {/* LEFT */}
//             <div className="flex-1 pr-4">
//           {/* Activities */}
//           <div className="mb-5">
//             <p className="text-[16px] font-bold mb-10">Activities:</p>
//             <div className="flex gap-0 mb-8">
//               {['On Street', 'Car Park', 'Enforcement'].map(label => (
//                 <div key={label} className="flex flex-col items-center gap-0">
//                     <div className="w-40 h-28  flex items-center justify-center text-gray-400 text-[11px]">
//                    {label === 'On Street' && <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '200px', objectFit: 'contain' }} />  }
//                                                              {label === 'Car Park' &&  <img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '200px', objectFit: 'contain' }} />}
//                                                              {label === 'Enforcement' &&  <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '200px', objectFit: 'contain' }} />}
//                   </div>
//                   {/* <span className="text-[13px] font-semibold">{label}</span> */}
//                 </div>
//               ))}
//             </div>
//           </div>

       

//               {/* On Street icon + profile info */}
//               <div className="flex items-start gap-3 mb-5">
//                  <div className="w-10 h-8   flex items-center justify-center text-[8px] text-gray-400"><img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '48px', objectFit: 'contain' }} /></div>
//                 <div className="flex flex-col gap-1.5">
//                   {/* Total Bays */}
//                   <span className="text-[12px]">
//                     {pd.total_bays?.label}{' '}
//                     <strong>
//                       <input type="text" value={pd.total_bays?.value || ''}
//                         onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" />
//                     </strong>
//                   </span>

//                   {/* Contract Term */}
//                   <div className="flex items-center gap-2 ml-4">
//                     <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                     <span className="text-[12px] flex items-center flex-wrap gap-1">
//                       Contract term{' '}
//                       <strong><input type="text" value={pd.contract_term?.value || ''}
//                         onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-14" /></strong>
//                       {' start date '}
//                       <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                         onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
//                       {' to '}
//                       <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                         onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                     </span>
//                   </div>

//                   {/* Operational Hours */}
//                   <div className="flex items-center gap-2 ml-4">
//                     <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                     <span className="text-[12px] flex items-center flex-wrap gap-1">
//                       Operational Hours{' '}
//                       <strong><input type="text" value={pd.operational_hours?.value || ''}
//                         onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
//                       {' Hours Per day '}
//                       <strong><input type="text" value={pd.operational_hours?.from || ''}
//                         onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-10" /></strong>
//                       {' to '}
//                       <strong><input type="text" value={pd.operational_hours?.to || ''}
//                         onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-10" />
//                       {' Hours'}
//                       </strong>
//                     </span>
//                   </div>

//                   {/* Rate Per Hour */}
//                   <div className="flex items-center gap-2 ml-4">
//                     <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                     <span className="text-[12px]">
//                       Rate per Hour{' '}
//                       <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                         onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
//                     </span>
//                   </div>

//                   {/* Assets Deployed */}
//                   <div className="flex items-center gap-2 ml-4">
//                     <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                     <span className="text-[12px]">Assets Deployed</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Violation Table */}
//               {violationTable && (
//                 <div className="">
//                   <table className="!border-collapse text-[8px]">
//   <thead>
//     <tr>
//       <th
//         colSpan={6}
//         className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]"
//       >
//         {violationTable.title}
//       </th>
//     </tr>
//     <tr>
//       {[
//         { label: 'City Code',         w: '65px' },
//         { label: 'Violation Code',    w: '65px' },
//         { label: 'Violation_Name_En', w: '210px', isLong: true },
//         { label: 'Ticket Charges',    w: '70px' },
//         { label: 'Tow Charges',       w: '65px' },
//         { label: 'Clamp Charges',     w: '65px' },
//       ].map(({ label, w }) => (
//         <th
//           key={label}
//           className="!border !border-black px-2 py-1 font-bold text-center"
//           style={{ minWidth: w }}
//         >
//           {label}
//         </th>
//       ))}
//     </tr>
//   </thead>

//   <tbody>
//     {violationTable.data.rows.map((row, rIdx) => (
//       <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
//         {[
//           { key: 'city_code',      w: '65px' },
//           { key: 'violation_code', w: '65px' },
//           { key: 'violation_name', w: '210px',isLong:true },
//           { key: 'ticket_charges', w: '70px' },
//           { key: 'tow_charges',    w: '65px' },
//           { key: 'clamp_charges',  w: '65px' },
//         ].map(({ key, w }) => (
//           <td key={key} className="!border !border-black px-1.5 py-0.5 align-center">
//             {key === 'violation_name' ? (
//               <textarea
//                 value={row[key] || ''}
//                 onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                 rows={1}
//                 className="!border-0 bg-transparent outline-none text-[9px] text-left resize-none overflow-hidden w-full"
//                 style={{
//                   maxWidth: w,
//                   minHeight: '22px',
//                   lineHeight: '1.1',
//                   padding: '2px 4px',
//                 }}
//                 onInput={e => {
//                   e.target.style.height = 'auto';
//                   e.target.style.height = e.target.scrollHeight + 'px';
//                 }}
//               />
//             ) : (
//               <input
//                 type="text"
//                 value={row[key] || ''}
//                 onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                 className="!border-0 bg-transparent outline-none text-[9px] text-center"
//                 style={{ width: w }}
//               />
//             )}
//           </td>
//         ))}
//       </tr>
//     ))}
//   </tbody>
// </table>
//                   {/* <table className="!border-collapse text-[8px]">
//                     <thead>
//                       <tr>
//                         <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
//                           {violationTable.title}
//                         </th>
//                       </tr>
//                       <tr className="">
//                         {[
//                           { label: 'City Code',         w: '65px'  },
//                           { label: 'Violation Code',    w: '65px'  },
//                           { label: 'Violation_Name_En', w: '210px',isLong: true },
//                           { label: 'Ticket Charges',    w: '70px'  },
//                           { label: 'Tow Charges',       w: '65px'  },
//                           { label: 'Clamp Charges',     w: '65px'  },
//                         ].map(({ label, w,isLong }) => (
//                           <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
//                             {label}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {violationTable.data.rows.map((row, rIdx) => (
//                         <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
//                           {[
//                             { key: 'city_code',      w: '65px'  },
//                             { key: 'violation_code', w: '65px'  },
//                             { key: 'violation_name', w: '210px' },
//                             { key: 'ticket_charges', w: '70px'  },
//                             { key: 'tow_charges',    w: '65px'  },
//                             { key: 'clamp_charges',  w: '65px'  },
//                           ].map(({ key, w }) => (
//                             <td key={key} className="!border !border-black px-1.5 py-0.5">
//                               <input type="text" value={row[key] || ''} onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                                 className="!border-0 bg-transparent outline-none text-[8px]" style={{ width: w }} />
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table> */}
//                 </div>
//               )}
//             </div>

//             {/* RIGHT — Assets */}
//             <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//               onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//           </div>
//         </>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//           {/* LEFT */}
//           <div className="flex-1 pr-4">
//             <div className="flex items-start gap-4 mb-4">
//               {/* Car Park icon */}
//               {/* <div className="flex flex-col items-center !border !border-gray-300 rounded p-2 bg-gray-50 w-20 flex-shrink-0">
//                 <span className="text-[8px] text-gray-500 mb-1">Car Park</span>
//                 <div className="text-2xl">🏢</div>
//               </div> */}
//               <div className="flex flex-col items-center  rounded  bg-gray-50 w-20 flex-shrink-0">
//                              <img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
//                             </div>

//               <div className="flex flex-col gap-1.5">
//                 {/* Total Bays */}
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-40"
//                       placeholder="............" />
//                   </strong>
//                 </span>

//                 {/* Contract Term */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Contract term{' '}
//                     <strong><input type="text" value={pd.contract_term?.value || ''}
//                       onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24"
//                       placeholder="........." /></strong>
//                     {'; start date '}
//                     <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                       onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-28"
//                       placeholder="................" /></strong>
//                     {' to '}
//                     <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-28"
//                       placeholder="................" /></strong>
//                   </span>
//                 </div>

//                 {/* Operational Hours */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Operational Hours{' '}
//                     <strong><input type="text" value={pd.operational_hours?.value || ''}
//                       onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16"
//                       placeholder="........" /></strong>
//                     {' '}
//                     <strong><input type="text" value={pd.operational_hours?.unit || ''}
//                       onChange={e => patchProfile('operational_hours', 'unit', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32"
//                       placeholder="Hours Per day" /></strong>
//                   </span>
//                 </div>

//                 {/* Rate Per Hour */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Rate per Hour <strong>SAR{' '}</strong>
//                     <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24"
//                       placeholder="........" /></strong>
//                   </span>
//                 </div>

//                 {/* Assets Deployed */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>

//                 {/* Membership Rates */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Membership Rates:{' '}
//                     <input type="text" value={pd.membership_rates?.value || ''}
//                       onChange={e => patchProfile('membership_rates', 'value', e.target.value)}
//                       className="outline-none bg-transparent !border-0 text-[12px] w-48" />
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — Assets */}
//           <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//         </div>
//       )}

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default BaljurashiProfile;










import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
    { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: '-',                      items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: '-',                      items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const BALJURASHI_PROFILE_CONFIG = {

  // ── Baljurashi On-Street ─────────────────────────────────────────────
  baljurashi_on_street_profile: {
    profileKey:   'baljurashi_on_street_profile',
    violationKey: 'baljurashi_on_street_violations',
    assetsKey:    'baljurashi_on_street_assets',
    pageType:     'on_street',

    profileFallback: {
      table_key: 'baljurashi_on_street_profile',
      title: 'Baljurashi On Street - Profile',
      data: {
        total_bays:        { label: 'Total On-Street Parking Bays', value: '1,350' },
        contract_term:     { value: '25 years' },
        contract_period:   { start_date: '27/10/2021', end_date: '29/01/2046' },
        operational_hours: { value: '14 Hours', from: '08:00', to: '22:00' },
        rate_per_hour:     { value: 'SAR 03 + 15% VAT' },
      },
    },

    violationFallback: {
      table_key: 'baljurashi_on_street_violations',
      title: 'Al Baljurashi On Street Violation Summary (Excluding Vat)',
      data: {
        rows: [
          { city_code: 'BLJRSIE', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                    ticket_charges: '200',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',    ticket_charges: '100',           tow_charges: '-',       clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                    ticket_charges: '100',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                            ticket_charges: '100',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                         ticket_charges: '300',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                               ticket_charges: '300',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                   ticket_charges: '900',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                             ticket_charges: '500',           tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                          ticket_charges: '0',             tow_charges: '250/1250', clamp_charges: '0' },
          { city_code: 'BLJRSIE', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                      ticket_charges: '20/50 per day', tow_charges: '0',       clamp_charges: '0' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'baljurashi_on_street_assets',
      title: 'Baljurashi On-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evDipG100: '1',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '2', ipBarrier: '-', anprCamera: '-',
          slidingGate: '2', left: '2',
          pnds: '72', tpalTx: '45', tpalV2: '27',
          enfDevice: '-', printer: '20', bixolon: '20',
          supportVehicle: '1',
        }),
      },
    },
  },

  // ── Baljurashi Off-Street ────────────────────────────────────────────
  baljurashi_off_street_profile: {
    profileKey:    'baljurashi_off_street_profile',
    assetsKey:     'baljurashi_off_street_assets',
    pageType:      'off_street',

    profileFallback: {
      table_key: 'baljurashi_off_street_profile',
      title: 'Baljurashi Off-Street Profile',
      data: {
        total_bays:        { label: 'Total Off Street Car Park Bays', value: '' },
        contract_term:     { value: '' },
        contract_period:   { start_date: '', end_date: '' },
        operational_hours: { value: '', unit: 'Hours Per day' },
        rate_per_hour:     { value: '' },
        membership_rates:  { value: '' },
      },
    },

    assetsFallback: {
      table_key: 'baljurashi_off_street_assets',
      title: 'Baljurashi Off-Street',
      data: {
        groups: makeAssetGroups({}), // all dashes — empty profile
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const BaljurashiProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = BALJURASHI_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving]             = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable]     = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable]       = useState(cfg.assetsFallback);
  const [violationTable, setViolationTable] = useState(cfg.violationFallback || null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0030018",
        year: year,
        month: month,
        device_onstreet: "BLJ",
        type: "on_street"
      } : {
        contract: "0030019",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        if (cfg.violationKey) setViolationTable(find(cfg.violationKey, cfg.violationFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      const tables = [
        { table_key: profileTable.table_key, title: profileTable.title, data: profileTable.data },
        { table_key: assetsTable.table_key,  title: assetsTable.title,  data: assetsTable.data  },
      ];
      if (violationTable) tables.push({ table_key: violationTable.table_key, title: violationTable.title, data: violationTable.data });

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1, tables,
      });
      if (!res?.success) throw new Error(res?.message);
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleViolationCell = (rIdx, key, value) => {
    setViolationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const pd         = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType   = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <>
          <div className="flex flex-row gap-0 !border-2 !border-black p-3">
            {/* LEFT */}
            <div className="flex-1 pr-4">
              {/* Activities */}
              <div className="mb-5">
                <p className="text-[16px] font-bold mb-10">Activities:</p>
                <div className="flex gap-0 mb-8">
                  {['On Street', 'Car Park', 'Enforcement'].map(label => (
                    <div key={label} className="flex flex-col items-center gap-0">
                      <div className="w-40 h-28 flex items-center justify-center text-gray-400 text-[11px]">
                        {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '200px', objectFit: 'contain' }} />}
                        {label === 'Car Park' && <img src={CarPark} alt="Car Park" style={{ height: '200px', objectFit: 'contain' }} />}
                        {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '200px', objectFit: 'contain' }} />}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* On Street icon + profile info */}
              <div className="flex items-start gap-3 mb-5">
                <div className="w-10 h-8 flex items-center justify-center text-[8px] text-gray-400">
                  <img src={CarPark} alt="Car Park" style={{ height: '48px', objectFit: 'contain' }} />
                </div>
                <div className="flex flex-col gap-1.5">
                  {/* 🔥 READ-ONLY Total Bays */}
                  <span className="text-[12px]">
                    {pd.total_bays?.label}{' '}
                    <strong>
                      <input 
                        type="text" 
                        value={effectiveTotalBays}
                        readOnly 
                        disabled
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                      />
                    </strong>
                  </span>

                  {/* Contract Term - Editable */}
                  <div className="flex items-center gap-2 ml-4">
                    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                    <span className="text-[12px] flex items-center flex-wrap gap-1">
                      Contract term{' '}
                      <strong><input type="text" value={pd.contract_term?.value || ''}
                        onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-14" /></strong>
                      {' start date '}
                      <strong><input type="text" value={pd.contract_period?.start_date || ''}
                        onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
                      {' to '}
                      <strong><input type="text" value={pd.contract_period?.end_date || ''}
                        onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
                    </span>
                  </div>

                  {/* Operational Hours - Editable */}
                  <div className="flex items-center gap-2 ml-4">
                    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                    <span className="text-[12px] flex items-center flex-wrap gap-1">
                      Operational Hours{' '}
                      <strong><input type="text" value={pd.operational_hours?.value || ''}
                        onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
                      {' Hours Per day '}
                      <strong><input type="text" value={pd.operational_hours?.from || ''}
                        onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-10" /></strong>
                      {' to '}
                      <strong><input type="text" value={pd.operational_hours?.to || ''}
                        onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-10" />
                      {' Hours'}
                      </strong>
                    </span>
                  </div>

                  {/* Rate Per Hour - Editable */}
                  <div className="flex items-center gap-2 ml-4">
                    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                    <span className="text-[12px]">
                      Rate per Hour{' '}
                      <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                        onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
                    </span>
                  </div>

                  {/* Assets Deployed */}
                  <div className="flex items-center gap-2 ml-4">
                    <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                    <span className="text-[12px]">Assets Deployed</span>
                  </div>
                </div>
              </div>

              {/* Violation Table - Editable */}
              {violationTable && (
                <div className="">
                  <table className="!border-collapse text-[8px]">
                    <thead>
                      <tr>
                        <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
                          {violationTable.title}
                        </th>
                      </tr>
                      <tr>
                        {[
                          { label: 'City Code',         w: '65px' },
                          { label: 'Violation Code',    w: '65px' },
                          { label: 'Violation_Name_En', w: '210px', isLong: true },
                          { label: 'Ticket Charges',    w: '70px' },
                          { label: 'Tow Charges',       w: '65px' },
                          { label: 'Clamp Charges',     w: '65px' },
                        ].map(({ label, w }) => (
                          <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
                            {label}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {violationTable.data.rows.map((row, rIdx) => (
                        <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                          {[
                            { key: 'city_code',      w: '65px' },
                            { key: 'violation_code', w: '65px' },
                            { key: 'violation_name', w: '210px', isLong: true },
                            { key: 'ticket_charges', w: '70px' },
                            { key: 'tow_charges',    w: '65px' },
                            { key: 'clamp_charges',  w: '65px' },
                          ].map(({ key, w, isLong }) => (
                            <td key={key} className="!border !border-black px-1.5 py-0.5 align-center">
                              {isLong ? (
                                <textarea
                                  value={row[key] || ''}
                                  onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                  rows={1}
                                  className="!border-0 bg-transparent outline-none text-[9px] text-left resize-none overflow-hidden w-full"
                                  style={{
                                    minWidth: '210px',
                                    minHeight: '22px',
                                    lineHeight: '1.1',
                                    padding: '2px 4px',
                                  }}
                                  onInput={e => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = e.target.scrollHeight + 'px';
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  value={row[key] || ''}
                                  onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                  className="!border-0 bg-transparent outline-none text-[9px] text-center"
                                  style={{ width: w }}
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* RIGHT — Assets */}
            <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
              onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
          </div>
        </>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">
          {/* LEFT */}
          <div className="flex-1 pr-4">
            <div className="flex items-start gap-4 mb-4">
              {/* Car Park icon */}
              <div className="flex flex-col items-center rounded bg-gray-50 w-20 flex-shrink-0">
                <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
              </div>

              <div className="flex flex-col gap-1.5">
                {/* 🔥 READ-ONLY Total Bays */}
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-40 cursor-default"
                      placeholder="............" />
                  </strong>
                </span>

                {/* Contract Term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Contract term{' '}
                    <strong><input type="text" value={pd.contract_term?.value || ''}
                      onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24"
                      placeholder="........." /></strong>
                    {'; start date '}
                    <strong><input type="text" value={pd.contract_period?.start_date || ''}
                      onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-28"
                      placeholder="................" /></strong>
                    {' to '}
                    <strong><input type="text" value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-28"
                      placeholder="................" /></strong>
                  </span>
                </div>

                {/* Operational Hours - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Operational Hours{' '}
                    <strong><input type="text" value={pd.operational_hours?.value || ''}
                      onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16"
                      placeholder="........" /></strong>
                    {' '}
                    <strong><input type="text" value={pd.operational_hours?.unit || ''}
                      onChange={e => patchProfile('operational_hours', 'unit', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32"
                      placeholder="Hours Per day" /></strong>
                  </span>
                </div>

                {/* Rate Per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Rate per Hour <strong>SAR{' '}</strong>
                    <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24"
                      placeholder="........" /></strong>
                  </span>
                </div>

                {/* Assets Deployed */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>

                {/* Membership Rates - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Membership Rates:{' '}
                    <input type="text" value={pd.membership_rates?.value || ''}
                      onChange={e => patchProfile('membership_rates', 'value', e.target.value)}
                      className="outline-none bg-transparent !border-0 text-[12px] w-48" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT — Assets */}
          <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
            onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
        </div>
      )}
    </div>
  );
};

export default BaljurashiProfile;